import { canvasWorkingLabels, summarizeCanvasProgress, type CanvasProgressInput } from './canvas-progress-summary';

/** Show recorded concept/research progress directly, without an empty disclosure. */
export function ThinkingBlock({ msgId, progress, isStreaming }: { msgId: string; progress: CanvasProgressInput; isStreaming: boolean }) {
  if (!progress.conceptDraftProgress && !progress.conceptsRun && !progress.webResearchStatus && !progress.playbookProgress && !progress.agentTaskGroups?.length) return null;
  const lines = summarizeCanvasProgress(progress, isStreaming).filter(line => line !== 'Waiting for progress updates.' && line !== 'No recorded progress details.');
  return <div data-testid={`classifier-reasoning-${msgId}`} style={{ marginBottom: 12, padding: '16px 20px', borderRadius: 16, background: '#eceef3', fontSize: 13, color: '#5b5f65', lineHeight: 1.6 }}>
    {lines.map((line, index) => <div key={index}>{line}</div>)}
  </div>;
}

/** Live project state is authoritative; saved unfinished cards are history. */
export function BottomStatusLine({ isTyping, progress = {} }: { isTyping: boolean; progress?: CanvasProgressInput }) {
  if (!isTyping) return null;
  return <RotatingStatus progress={progress} />;
}

function RotatingStatus({ progress }: { progress: CanvasProgressInput }) {
  const labels = canvasWorkingLabels(progress);
  const label = labels[0];
  return <div role="status" data-testid="chat-working-status" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 8px', fontSize: 13, color: '#777b80' }}>
    <span aria-hidden="true" style={{ width: 6, height: 6, borderRadius: '50%', background: '#A04F6A' }} />
    <span aria-hidden="true">{label}…</span>
    <span className="sr-only">{labels[0]}.</span>
  </div>;
}
